<template>
  <div class="home">
    Please visit the firmware update page from the link presented in the WiBotic system GUI.
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home'
}
</script>
